export default __webpack_public_path__ + "static/media/menuArrow.566e712c.svg";